import { listOfColorsShort } from '@common/_assets/listOfColors.js';
import { ColorUtils } from '@common/utils';
import { observer } from 'mobx-react';
import React, { useCallback, useMemo, useState } from 'react';
import { Dropdown, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { useSlate } from 'slate-react';
import { RichTextBoxUtils } from '../RichTextBoxUtils';
import { RichTextBoxEditor } from '../richTextEditorTypes';

const ColorTile = (props: {
  editor: RichTextBoxEditor;
  color: string;
  name: string;
  isActive: boolean;
  setShowDropDown: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
  return (
    <OverlayTrigger
      placement="bottom"
      overlay={
        <Tooltip>
          <span>{props.name}</span>
        </Tooltip>
      }
    >
      <div className="color-tile">
        <span
          className="color-btn btn cursor-pointer"
          title={props.name}
          onClick={() => {
            RichTextBoxUtils.setActiveColor(props.editor, props.color);
            props.setShowDropDown(false);
          }}
          style={{ color: props.color }}
        >
          <span className="fa-stack fa-small">
            <i className="fa fa-square fa-stack-2x" />
            <i
              className="fa fa-check fa-stack-1x"
              style={{
                color: props.isActive
                  ? ColorUtils.invertColor(props.color, true, 'white', 'black')
                  : 'transparent',
              }}
            />
          </span>
        </span>
      </div>
    </OverlayTrigger>
  );
};

export const RichTextBoxColorPickerButton = observer(
  (props?: React.HTMLAttributes<HTMLButtonElement>) => {
    const editor = useSlate();
    const color = RichTextBoxUtils.getActiveColor(editor);
    const [showDropdown, setShowDropDown] = useState(false);
    const colorTiles = useMemo(() => {
      return listOfColorsShort
        .sort((a, b) => {
          if (a[1] === b[1]) return 0;
          if (a[1] < b[1]) return -1;
          if (a[1] > b[1]) return 1;
          return 0;
        })
        .map((colorArray, index) => {
          return (
            <ColorTile
              key={index}
              {...{ editor, setShowDropDown }}
              name={colorArray[0]}
              color={colorArray[1]}
              isActive={
                colorArray[1] === RichTextBoxUtils.getActiveColor(editor)
              }
            />
          );
        });
    }, [editor]);

    const onToggle = useCallback(
      (nextShow: boolean) => {
        setShowDropDown(nextShow);
      },
      [setShowDropDown],
    );

    return (
      <>
        <Dropdown
          show={showDropdown}
          className="color-picker"
          drop="down"
          autoClose={true}
          onToggle={onToggle}
        >
          <OverlayTrigger
            placement="bottom"
            overlay={<Tooltip>{props?.title}</Tooltip>}
          >
            <Dropdown.Toggle
              disabled={!editor.selection}
              variant="secondary"
              className="richtextbox-toolbar-button btn btn-outline-primary btn-secondary"
            >
              <i
                className="fa fa-font"
                style={{
                  width: '20px',
                  borderBottom: color ? `6px solid ${color}` : 'none',
                }}
              ></i>
            </Dropdown.Toggle>
          </OverlayTrigger>
          <Dropdown.Menu style={{ minWidth: '400px' }}>
            <div className="color-dropdown d-flex flex-wrap">{colorTiles}</div>
          </Dropdown.Menu>
        </Dropdown>
      </>
    );
  },
);
